import { Link } from 'react-router-dom';
import { Card, EmptyState } from '@onepos/ui';

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState
        title="Bunday sahifa yo‘q"
        action={
          <Link className="op-btn op-btn--primary" to="/">
            Bosh sahifaga qaytish
          </Link>
        }
      >
        Bu bo&apos;lim hali qurilmagan yoki manzil noto&apos;g&apos;ri.
      </EmptyState>
    </Card>
  );
}
